import { createFileRoute } from "@tanstack/react-router"
import Season from "@/app/settings/analysis-groups/season/page"

export const Route = createFileRoute("/settings/analysis-groups/season")({
  component: Season,
})
